import { Injectable, inject } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable, catchError } from 'rxjs'

import { environment } from '../../environments/environment'

import { ErrorService } from './error.service'
import {
  Regulation,
  RegulationSubstancesResult,
  SubstanceListFilter,
} from '../types/chemistry'

@Injectable({
  providedIn: 'root',
})
export class RegulationService {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'regulations'

  getAll(): Observable<Array<Regulation>> {
    return this.http
      .get<Array<Regulation>>(this.URL)
      .pipe(catchError(this.errorService.handleError))
  }

  /**
   * Retrieves substances for a regulation
   * @param {number} page The current page number
   * @param {SubstanceListFilter} filter The filter values
   * @returns {Observable<RegulationSubstancesResult>} Results
   */
  getRegulationSubstances(
    page: number,
    filter: SubstanceListFilter,
  ): Observable<RegulationSubstancesResult> {
    let params = new HttpParams()
    params = params.set('page', page)
    if (filter.name != null) {
      params = params.set('name', filter.name)
    }

    if (filter.casNumber != null) {
      params = params.set('casNumber', filter.casNumber)
    }

    return this.http
      .get<RegulationSubstancesResult>(
        this.URL + `/${filter.regulationId}/substances`,
        {
          params,
        },
      )
      .pipe(catchError(this.errorService.handleError))
  }
}
